var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "xzdd" }, [
      _c("div", { staticClass: "addd", on: { click: _vm.androdios } }, [
        _c("img", {
          staticClass: "android",
          attrs: { src: require("../../static/image/android.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "andrxz" }, [_vm._v("立即下载")])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { height: "60%" } }, [
      _c("img", {
        staticClass: "sharet",
        attrs: { src: require("../../static/image/sharebj1.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3a4deea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3a4deea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/share.vue
// module id = null
// module chunks = 